import { bigWinService } from '../../services/helperServices/BigWinService';

export const bigWinAmountFontSizeHelper = (texture, text) => {
  texture.style.fontSize = 100;

  if (text.length === 12) {
    texture.style.fontSize = 100;
  } else if (text.length >= 13 && text.length < 15) {
    texture.style.fontSize = 86;
  } else if (text.length >= 15 && text.length < 17) {
    texture.style.fontSize = 75;
  } else if (text.length >= 17 && text.length < 20) {
    texture.style.fontSize = 70;
  } else {
    texture.style.fontSize = 60;
  }
};

export const handleBigWinClick = (event, self) => {
  if (self.checkTime()) {
    if (self.amountGrow.ended) {
      bigWinService.end();
    } else {
      self.amountGrow.stop();
    }
  }
};
